import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { downloadRoomRequestDocument } from "../../services/nonPublicRoomRequestService";
import Loader from "../../components/common/Loader";

export default function RequestDocumentPreview({ requestId }) {
  const { t } = useTranslation("roomAccess");
  const [document, setDocument] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    let objectUrl;
    setDocument(null); setError(false);
    downloadRoomRequestDocument(requestId, controller.signal).then(({ data }) => {
      if (controller.signal.aborted) return;
      const type = data.type?.split(";")[0]?.toLowerCase();
      if (!["application/pdf", "image/png", "image/jpeg"].includes(type)) throw new Error("Unsupported document type");
      objectUrl = URL.createObjectURL(data);
      setDocument({ url: objectUrl, type });
    }).catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [requestId]);

  if (error) return <p role="alert">{t("previewFailed")}</p>;
  if (!document) return <Loader />;
  return <div style={{ marginTop: 16 }}>
    {document.type === "application/pdf"
      ? <><iframe title={t("documentPreview")} src={document.url} style={{ width: "100%", height: "55vh", border: 0 }} />
        <p>{t("pdfPreviewHelp")}</p></>
      : <img src={document.url} alt={t("documentPreview")} style={{ display: "block", maxWidth: "100%", maxHeight: "55vh", objectFit: "contain", margin: "0 auto" }} />}
  </div>;
}
